import React from 'react'
import { ArrowDownward, ArrowForward } from '@mui/icons-material'
import { Grid as BaseGrid, styled } from '@mui/material'
import { Card as BaseCard } from '@chilecompra/react-kit/components'

export const ArrowDownIcon = styled(ArrowDownward)`
  &.MuiSvgIcon-root {
    aspect-ratio: 1/1;
    color: ${props => props.theme.palette.brand.primary};
    height: 24px;
    margin: auto -6px -4px -10px;

    &:hover {
      color: ${props => props.theme.palette.blue[35]};
    }
  }
`
export const ArrowForwardIcon = styled(ArrowForward)`
  &.MuiSvgIcon-root {
    aspect-ratio: 1/1;
    color: ${props => props.theme.palette.brand.primary};
    height: 18px;
    margin: auto -6px 0px -10px;
    vertical-align: top;

    &:hover {
      color: ${props => props.theme.palette.blue[35]};
    }
  }
`

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  align-items: ${props => props.alignItems};
  display: flex;
  height: ${props => props.height};
  margin: ${props => props.margin};
  text-align: ${props => props.textAlign};
  width: ${props => props.width};
`

export const CardItem = styled('div')`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: ${props => props.direction || 'flex'};
  padding: ${props => props.padding};
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Link = styled(({ children, textAlign, textDecoration, ...props }) => <a {...props}>{children}</a>)`
  align-content: baseline;
  align-items: center;
  color: ${({ color, theme }) => (color === 'primary' ? theme.palette.blue[50] : theme.palette.gray[50])};
  cursor: pointer;
  display: ${props => props.display || 'flex'};
  font-family: Roboto;
  font-size: 14px;
  font-style: ${props => (props.italic ? 'italic' : 'initial')};
  line-height: 18px;
  text-align: ${props => props.textAlign || 'initial'};
  text-decoration: ${props => props.textDecoration || 'none'};
  font-weight: ${props => props.fontWeight || 'normal'};
  ${props => props.theme.breakpoints.only('xs')} {
    align-items: end;
    flex-wrap: wrap;
    justify-content: center;
  }

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    & svg {
      color: ${props => props.theme.palette.blue[35]};
    }
  }
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  margin: ${props => props.margin};
  width: 82px;
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)`
  margin: 30px 0 0 0;
`

export const TableContainer = styled('div')`
  margin-bottom: 20px;
  & > div > div:last-child {
    &.MuiGrid-container {
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;

      ${props => props.theme.breakpoints.down('md')} {
        justify-content: center;
      }
      & > div:first-child {
        max-width: fit-content;
      }
      & > div:last-child {
        nav {
          margin: 0 auto;
          ul > li {
            margin: 0;
            padding: 0;
            ${props => props.theme.breakpoints.down('md')} {
              [type='button'] {
                font-size: 11px;
                margin: 0;
              }
            }
          }
        }
      }
    }
  }
`

export const TableLink = styled(({ ...props }) => <a {...props} />)`
  color: ${({ theme }) => theme.palette.blue[50]};
  cursor: pointer;
  text-decoration: ${props => props.textDecoration || 'none'};

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const WarningImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: 48px;
  margin: ${props => props.margin};
  width: 48px;
`

export const Root = styled('div')`
  width: 100%;
`
export const RedirectLink = styled(Link)`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
    & svg {
      color: ${props => props.theme.palette.blue[35]};
    }
  }
`
export const ColumnChart = styled(({ ...props }) => <BaseGrid item {...props} />)`
  align-content: ${props => props.alignContent};
  display: flex;
  flex-direction: ${props => props.flexDirection};
  justify-content: ${props => props.justifyContent};
  flex-wrap: ${props => props.flexWrap};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: ${props => props.width};
`
export const RowChart = styled(({ ...props }) => <BaseGrid container {...props} />)`
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  border-radius: 4px;
  justify-content: ${props => props.justifyContent};
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: ${props => props.width};
`
